export default function CloseIcon(props) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="10.8875" y="3.54456" width="1.53972" height="10.778" transform="rotate(45 10.8875 3.54456)" fill="#416267" />
            <rect x="3.26636" y="4.6333" width="1.53972" height="10.778" transform="rotate(-45 3.26636 4.6333)" fill="#416267" />
        </svg>

    )
}